import { render, staticRenderFns } from "./FormDelGroup.vue?vue&type=template&id=e8040896&scoped=true"
import script from "./FormDelGroup.vue?vue&type=script&lang=js"
export * from "./FormDelGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8040896",
  null
  
)

export default component.exports